const MAINTENANCE_END_UTC = new Date("2026-10-24T10:00:00Z");

function MaintenanceBanner() {
  if (new Date() > MAINTENANCE_END_UTC) return null;

  return (
    <div style={styles.banner}>
      <span style={styles.icon}>&#9888;</span>
      <div>
        <strong>Scheduled System Maintenance</strong>
        <p style={styles.text}>
          Scheduled maintenance planned on{" "}
          <strong>Saturday, October 24, 2026</strong>, from{" "}
          <strong>3:00 AM to 5:00 AM CT</strong> (1:00–3:00 AM PT / 4:00–6:00
          AM ET). System may be unavailable for up to 2 hours during this
          window. Avoid scheduling critical operations during this time.
        </p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  banner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#FFF3CD",
    borderBottom: "2px solid #FFCC00",
    padding: "8px 20px",
    fontFamily: "inherit",
    fontSize: "12px",
    color: "#664D03",
  },
  icon: {
    fontSize: "16px",
    lineHeight: "1.4",
    flexShrink: 0,
  },
  text: {
    margin: "2px 0 0",
    lineHeight: "1.35",
  },
};

export default MaintenanceBanner;
